import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Column 1 - Brand */}
          <div className="lg:col-span-1">
            <img src="https://static.readdy.ai/image/ecd9e0a88a19846633f9ef23a8543c57/a22502e2a1fd52e546dc9b0190a6b81c.jpeg" alt="SEOgenia" className="h-14 mb-4" />
            <p className="text-gray-400 mb-6 text-sm leading-relaxed">Automatización SEO con IA Generativa. Llevamos tu sitio web al siguiente nivel con tecnología de vanguardia.</p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 rounded-full border-2 border-gray-700 flex items-center justify-center hover:bg-gray-800 hover:border-gray-600 transition-all duration-300 cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border-2 border-gray-700 flex items-center justify-center hover:bg-gray-800 hover:border-gray-600 transition-all duration-300 cursor-pointer">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border-2 border-gray-700 flex items-center justify-center hover:bg-gray-800 hover:border-gray-600 transition-all duration-300 cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Column 2 - Company */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Empresa</h3>
            <ul className="space-y-3">
              <li><Link to="/como-lo-hacemos" className="text-gray-400 hover:text-white hover:translate-x-1 inline-block transition-all duration-300 text-sm cursor-pointer">Cómo lo Hacemos</Link></li>
              <li><Link to="/blog" className="text-gray-400 hover:text-white hover:translate-x-1 inline-block transition-all duration-300 text-sm cursor-pointer">Blog</Link></li>
            </ul>
          </div>

          {/* Column 3 - Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Servicios</h3>
            <ul className="space-y-3">
              <li><Link to="/servicios/arquitectura-semantica" className="text-gray-400 hover:text-white hover:translate-x-1 inline-block transition-all duration-300 text-sm cursor-pointer">Arquitectura Semántica</Link></li>
              <li><Link to="/servicios/schema-markup-avanzado" className="text-gray-400 hover:text-white hover:translate-x-1 inline-block transition-all duration-300 text-sm cursor-pointer">Schema Markup Avanzado</Link></li>
              <li><Link to="/servicios/seo-agentes-ia" className="text-gray-400 hover:text-white hover:translate-x-1 inline-block transition-all duration-300 text-sm cursor-pointer">SEO para Agentes IA</Link></li>
              <li><Link to="/servicios/voice-search-seo" className="text-gray-400 hover:text-white hover:translate-x-1 inline-block transition-all duration-300 text-sm cursor-pointer">Voice Search SEO</Link></li>
              <li><Link to="/servicios/progressive-web-app" className="text-gray-400 hover:text-white hover:translate-x-1 inline-block transition-all duration-300 text-sm cursor-pointer">Progressive Web App</Link></li>
              <li><Link to="/servicios/optimizacion-extrema" className="text-gray-400 hover:text-white hover:translate-x-1 inline-block transition-all duration-300 text-sm cursor-pointer">Optimización Extrema</Link></li>
            </ul>
          </div>

          {/* Column 4 - Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-gray-400 text-sm">
                <i className="ri-mail-line text-gray-500"></i>
                <span>info@seogenia.es</span>
              </li>
              <li className="flex items-center gap-2 text-gray-400 text-sm">
                <i className="ri-phone-line text-gray-500"></i>
                <span>+34 659 357 423</span>
              </li>
              <li className="flex items-center gap-2 text-gray-400 text-sm">
                <i className="ri-map-pin-line text-gray-500"></i>
                <span>Madrid, España</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">© 2026 SEOgenia.es - Todos los derechos reservados</p>
          <div className="flex items-center gap-6">
            <Link to="/politica-privacidad" className="text-gray-500 hover:text-white text-sm transition-colors cursor-pointer">Política de Privacidad</Link>
            <span className="text-gray-700">|</span>
            <Link to="/politica-cookies" className="text-gray-500 hover:text-white text-sm transition-colors cursor-pointer">Política de Cookies</Link>
            <span className="text-gray-700">|</span>
            <Link to="/terminos-condiciones" className="text-gray-500 hover:text-white text-sm transition-colors cursor-pointer">Términos y Condiciones</Link>
            <span className="text-gray-700">|</span>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white text-sm transition-colors cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
